import React from 'react'

const styles = {
  container: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
    padding: '8px 0',
  },
  button: {
    padding: '8px 16px',
    border: '2px solid var(--color-border)',
    background: '#fff',
    fontWeight: '600',
    cursor: 'pointer',
    fontSize: '0.875rem',
  },
  hintsCount: {
    fontSize: '0.875rem',
    color: 'var(--color-muted)',
    marginLeft: '8px',
  },
}

export default function HintsToolbar({
  onCheckCell,
  onCheckWord,
  onCheckPuzzle,
  onRevealCell,
  onRevealWord,
  hintsUsed = 0,
  disabled = false,
}) {
  return (
    <div style={styles.container}>
      <button
        style={styles.button}
        onClick={onCheckCell}
        disabled={disabled}
        title="Check if current cell is correct"
      >
        Check Cell
      </button>
      <button
        style={styles.button}
        onClick={onCheckWord}
        disabled={disabled}
        title="Check if current word is correct"
      >
        Check Word
      </button>
      <button
        style={styles.button}
        onClick={onRevealCell}
        disabled={disabled}
        title="Reveal the correct letter for this cell"
      >
        Reveal Cell
      </button>
      <button
        style={styles.button}
        onClick={onRevealWord}
        disabled={disabled}
        title="Reveal the correct word"
      >
        Reveal Word
      </button>
      <button
        style={styles.button}
        onClick={onCheckPuzzle}
        disabled={disabled}
        title="Check all cells in the puzzle"
      >
        Check Puzzle
      </button>
      {hintsUsed > 0 && (
        <span style={styles.hintsCount}>
          ({hintsUsed} hint{hintsUsed !== 1 ? 's' : ''} used)
        </span>
      )}
    </div>
  )
}
